import React, { use, useEffect, useRef, useState } from "react";
import { DimensionFieldsModel } from "../../_core/_model.ts";
import { fieldType, Separators } from "../../Constants.ts";

interface request {
    fields: DimensionFieldsModel[],
    initValues: string,
    onChange: (val: string) => void
}
export function FieldCondition({ fields, initValues, onChange }: request) {
    const [selectedField, setSelectedField] = useState<DimensionFieldsModel>();
    const [selected, setSelected] = useState({ fieldId: "", value: "" })
    const textMeasureRef = useRef<HTMLSpanElement>(null);
    const [selectWidth, setSelectWidth] = useState(100);

    useEffect(() => {
        if (typeof selectedField == 'undefined')
            setSelectedField(fields[0]);
    }, [fields])

    useEffect(() => {
        if (initValues != "") {
            let arr = initValues.split(Separators.column);
            if (arr.length > 3) {
                setSelected({
                    fieldId: arr[0],
                    value: arr[2].replace(/'/gi, "")
                })
            }
            else {
                setSelected({
                    fieldId: "",
                    value: ""
                })
            }
        }
    }, [initValues])

    useEffect(() => {
        if (textMeasureRef.current) {
            const width = textMeasureRef.current.offsetWidth + 240; // some padding
            setSelectWidth(width);
        }
    }, [selected.fieldId]);
    return (
        fields.length > 0 &&
        <div className="d-flex flex-row align-items-center gap-2 p-1">
            <span
                ref={textMeasureRef}
                style={{
                    visibility: "hidden",
                    position: "absolute",
                    whiteSpace: "nowrap",
                    fontSize: "1rem"
                }}
            >
                {
                    fields.find(f => f.columnName === selected.fieldId)?.columnDescription ||
                    fields[0].columnDescription
                }
            </span>
            {
                fields.length > 1 ?
                    <select
                        value={selected.fieldId}
                        className="form-select"
                        style={{ width: `${selectWidth}px` }}
                        onChange={(e) => {
                            let f = fields.find((x) => x.columnName === e.target.value);
                            if (f) {
                                setSelectedField(f);
                                let v = `${e.target.value}${Separators.column}=${Separators.column}''${Separators.column}Or`;
                                onChange(v);
                            }
                        }}
                    >
                        {fields.map((f) => (
                            <option key={f.columnName} value={f.columnName}>
                                {f.columnDescription}
                            </option>
                        ))}
                    </select> :
                    <div style={{ padding: "2px 6px 6px 6px" }} className="border rounded-2 text-nowrap text-muted-theme">{fields[0].columnDescription}
                    </div>
            }
            {
                typeof selectedField != 'undefined' &&
                    selectedField.fieldType == fieldType.text ?
                    <span>like</span> :
                    <span>=</span>
            }
            <input style={{ minWidth: "200px" }} value={selected.value}
                placeholder={typeof selectedField != 'undefined' ? `Enter ${selectedField.columnDescription} value/desciptions.` : "Select a field first"}
                className="form-control"
                onChange={(e) => {
                    let v = `${selectedField?.columnName}${Separators.column}=${Separators.column}'${e.target.value}'${Separators.column}Or`;
                    if (e.target.value.isEmpty())
                        v = `${selectedField?.columnName}${Separators.column}=${Separators.column}${Separators.column}Or`;
                    onChange(v);
                    if (typeof selectedField != 'undefined') {
                        setSelected({
                            fieldId: selectedField.columnName,
                            value: e.target.value
                        });
                    }
                }} />
        </div>
    )
}

export default FieldCondition;